import { useNavigate } from 'react-router-dom';
import { useOnboardingPassed } from '@entities/profile/api/useOnboardingPassed';
import { OnboardingCompleteStep } from '@shared/ui/onboarding-complete-step';

export const Completion = () => {
	const navigate = useNavigate();
	const { mutate, isPending } = useOnboardingPassed();

	const goToDashboard = () => {
		mutate(
			{ onboarding_passed: true },
			{
				onSuccess: () => navigate('/'),
			}
		);
	};

	return (
		<OnboardingCompleteStep
			title="Профиль готов!"
			subtitle="Теперь ученики могут записываться к вам на занятия. Вы всегда можете добавить учеников и настроить расписание в личном кабинете."
			buttonLabel="Перейти в личный кабинет"
			onSubmit={goToDashboard}
			isPending={isPending}
		/>
	);
};
